(function(){
  /* ============ CHECKOUT TRUST BOOST ============ */
  
  // 1. Urgency + Stock Counter on Product Pages
  function addUrgencyBanner() {
    if (!window.location.pathname.includes('/products/')) return;
    var banner = document.querySelector('#makne-trust-bar');
    if (!banner) return;
    
    var urgencyHTML = '<div id="makne-urgency" style="margin:12px 0;padding:12px 16px;background:linear-gradient(135deg,#fff3cd,#fff8e1);border:1px solid #ffd93d;border-radius:10px;font-family:system-ui,sans-serif;text-align:center">' +
      '<div style="font-size:14px;color:#856404;font-weight:600">🔥 ' + (Math.floor(Math.random()*30)+15) + ' people are viewing this right now</div>' +
      '<div style="font-size:12px;color:#856404;margin-top:4px">⏰ Ships in <b>24-48 hours</b> · Only ' + (Math.floor(Math.random()*8)+3) + ' left in stock</div>' +
    '</div>';
    banner.insertAdjacentHTML('afterend', urgencyHTML);
  }

  // 2. Delivery Estimate on Product Pages  
  function addDeliveryEstimate() {
    if (!window.location.pathname.includes('/products/')) return;
    var form = document.querySelector('form[action*="/cart/add"]') || document.querySelector('.product-form');
    if (!form) return;
    
    var today = new Date();
    var delivery = new Date(today.getTime() + (4*24*60*60*1000)); // 4 days from now
    var options = {weekday:'long', month:'short', day:'numeric'};
    var deliveryDate = delivery.toLocaleDateString('en-IN', options);
    
    var delivHTML = '<div id="makne-delivery" style="margin:10px 0;padding:10px 14px;background:#f0fff4;border:1px solid #c6f6d5;border-radius:8px;font-family:system-ui,sans-serif">' +
      '<div style="font-size:13px;color:#276749">📦 <b>Estimated Delivery:</b> ' + deliveryDate + '</div>' +
      '<div style="font-size:11px;color:#38a169;margin-top:3px">✅ Cash on Delivery Available · No advance payment needed</div>' +
    '</div>';
    form.insertAdjacentHTML('beforebegin', delivHTML);
  }
  
  // 4. Cart Page Trust Reinforcement
  function addCartTrust() {
    if (!window.location.pathname.includes('/cart')) return;
    var cartForm = document.querySelector('form[action*="/cart"]') || document.querySelector('.cart');
    if (!cartForm) return;
    if (document.getElementById('makne-cart-trust')) return;
    
    var cartTrustHTML = '<div id="makne-cart-trust" style="margin:16px 0;padding:16px;background:linear-gradient(135deg,#f0fff4,#fff);border:2px solid #48bb78;border-radius:12px;font-family:system-ui,sans-serif">' +
      '<div style="text-align:center;margin-bottom:10px;font-size:15px;font-weight:700;color:#276749">✅ Your Order is Protected</div>' +
      '<div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;text-align:center">' +
        '<div style="font-size:12px;color:#444"><span style="font-size:20px">💵</span><br><b>Cash on Delivery</b><br>Pay when you receive</div>' +
        '<div style="font-size:12px;color:#444"><span style="font-size:20px">🚚</span><br><b>Free Shipping</b><br>All over India</div>' +
        '<div style="font-size:12px;color:#444"><span style="font-size:20px">📦</span><br><b>Ships in 24-48h</b><br>Fast delivery</div>' +
        '<div style="font-size:12px;color:#444"><span style="font-size:20px">🔄</span><br><b>Easy Returns</b><br>No questions asked</div>' +
      '</div>' +
      '<div style="text-align:center;margin-top:10px;padding-top:10px;border-top:1px solid #c6f6d5;font-size:11px;color:#718096">🔒 Secure checkout powered by Shopify · 256-bit SSL encryption</div>' +
    '</div>';
    cartForm.insertAdjacentHTML('beforebegin', cartTrustHTML);
  }

  // 5. Recently Purchased Notification (Social Proof Popup)
  function showRecentPurchase() {
    if (document.getElementById('makne-recent-purchase')) return;
    
    var cities = ['Mumbai', 'Delhi', 'Bangalore', 'Pune', 'Hyderabad', 'Chennai', 'Kolkata', 'Jaipur', 'Lucknow', 'Ahmedabad'];
    var products = ['Mousse Eyeshadow — Diamond Brown', 'Mousse Eyeshadow — Rose Gold', 'Mousse Eyeshadow — Shine Peach', 'Mousse Eyeshadow — Pink Gold', 'Mousse Eyeshadow — Moon Pearl', 'Mousse Eyeshadow — Shine Coral', 'Mousse Eyeshadow — Charming Pink', 'Mousse Eyeshadow — Rosewood Shine', 'Mousse Eyeshadow — Mauve', 'Mousse Eyeshadow — Stardust'];
    var times = ['2 minutes ago', '5 minutes ago', '8 minutes ago', '12 minutes ago', '15 minutes ago'];
    
    var popup = document.createElement('div');
    popup.id = 'makne-recent-purchase';
    popup.style.cssText = 'position:fixed;bottom:20px;left:20px;background:#fff;border-radius:12px;box-shadow:0 4px 20px rgba(0,0,0,0.15);padding:14px 18px;z-index:9998;font-family:system-ui,sans-serif;max-width:300px;transform:translateY(100px);opacity:0;transition:all 0.4s ease';
    
    function showNotification() {
      var city = cities[Math.floor(Math.random()*cities.length)];
      var product = products[Math.floor(Math.random()*products.length)];
      var time = times[Math.floor(Math.random()*times.length)];
      
      popup.innerHTML = '<div style="display:flex;align-items:center;gap:10px">' +
        '<div style="font-size:24px">🛍️</div>' +
        '<div><div style="font-size:13px;font-weight:600;color:#333">Someone in ' + city + '</div>' +
        '<div style="font-size:12px;color:#666">purchased <b>' + product + '</b></div>' +
        '<div style="font-size:11px;color:#999">' + time + '</div></div>' +
        '<div onclick="this.parentElement.parentElement.style.transform=\'translateY(100px)\';this.parentElement.parentElement.style.opacity=\'0\'" style="cursor:pointer;color:#999;font-size:16px;position:absolute;top:8px;right:12px">×</div>' +
      '</div>';
      
      popup.style.transform = 'translateY(0)';
      popup.style.opacity = '1';
      
      setTimeout(function() {
        popup.style.transform = 'translateY(100px)';
        popup.style.opacity = '0';
      }, 5000);
    }
    
    document.body.appendChild(popup);
    
    // Show first after 8 seconds, then every 30-45 seconds
    setTimeout(showNotification, 8000);
    setInterval(showNotification, 30000 + Math.random()*15000);
  }

  // Initialize all
  function init() {
    addUrgencyBanner();
    addDeliveryEstimate();
    addCartTrust();
    showRecentPurchase();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 500);
  }
})();
